import { AnchorLink } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import CustomIcon from '../../../common/CustomIcons';
import SkeletonBox from '../../../common/SkeletonBox';
import MarketNews from '../MarketNews';
import useGetNews from './customHooks';

import './styles/index.css';

const NewsSection = ({ newsURL, viewAllNews, cargillNews, newsLinkLabel, noNewsMessage }) => {
  const { news, areNewsLoaded } = useGetNews(newsURL);

  return (
    <div className="news-section">
      {!areNewsLoaded ? (
        <div className="news-section__container">
          <div className="news-section-header">
            <SkeletonBox width="30%" height={30} />
            <SkeletonBox width="18%" height={30} />
          </div>
          <div className="news-wrapper">
            <SkeletonBox width="100%" height={260} />
            <SkeletonBox width="100%" height={260} />
            <SkeletonBox width="100%" height={260} />
            <SkeletonBox width="100%" height={260} />
          </div>
        </div>
      ) : (
        <div className="section__container">
          <div className="news-section-header">
            <span className="news-section-header__heading">{cargillNews}</span>
            <span className="new-section-header__link">
              <CustomIcon type="libraryBook" size="24" />
              <AnchorLink {...viewAllNews} />
            </span>
          </div>
          {news.length ? (
            <div className="news-wrapper">
              {news.map((item, index) => (
                <MarketNews key={index} item={item} linkLabel={newsLinkLabel} />
              ))}
            </div>
          ) : (
            <div className="no-news-wrapper card">
              <span className="no-news gamma">{noNewsMessage}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

NewsSection.propTypes = {
  isUnleashFlagReady: PropTypes.bool,
  newsURL: PropTypes.string.isRequired,
  viewAllNews: PropTypes.instanceOf(Object).isRequired,
  cargillNews: PropTypes.string,
  newsLinkLabel: PropTypes.string,
  noNewsMessage: PropTypes.string
};

NewsSection.defaultProps = {
  isUnleashFlagReady: false,
  cargillNews: '',
  newsLinkLabel: '',
  noNewsMessage: ''
};

export default NewsSection;
